import { FieldGroupValue, FieldValue } from "..";

const getEmptyClassGroup = (name: string = "", classes: FieldValue[] = []): FieldGroupValue => ({
  name,
  classes,
});

export default getEmptyClassGroup;
